import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { ArticleService } from 'src/app/services/article.service';
import { Chat } from 'src/app/services/chat.service';
import { FaqService } from 'src/app/services/faq.service';
import { MeService } from 'src/app/services/me.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { Domain } from 'src/app/services/domain.service';
import { selectDomain } from 'src/app/store/selectors/auth.selectors';
import { SearchResult } from 'src/app/services/search.service';
export interface Stars {
  icon: string;
  // rating: number;
  selected: boolean;
  background: string;
  textColor: string;
  altIconSrc: string;
}

@Component({
  selector: 'mvp-stars',
  templateUrl: './stars.component.html',
})
export class StarsComponent {
  @Input() type: string;
  @Input() uuid: string;
  @Input() canShare = false;
  @Input() faqSuggestions: SearchResult[] = [];
  @Output() shareClicked = new EventEmitter<void>();
  @Output() suggestionSelected = new EventEmitter<SearchResult>();

  environment = environment;

  displayText = 'vos représentants'; // Default text

  // stars: Stars[] = [
  //   {
  //     icon: 'frown',
  //     rating: 1,
  //     selected: false,
  //     background: 'bg-red-600',
  //     textColor: 'text-black',
  //     altIconSrc: 'assets/img/svg/frown.svg',
  //   },
  //   {
  //     icon: 'meh',
  //     rating: 3,
  //     selected: false,
  //     background: 'bg-yellow-500',
  //     textColor: 'text-black',
  //     altIconSrc: 'assets/img/svg/meh.svg',
  //   },
  //   {
  //     icon: 'smile',
  //     rating: 5,
  //     selected: false,
  //     background: 'bg-green-400',
  //     textColor: 'text-black',
  //     altIconSrc: 'assets/img/svg/smile.svg',
  //   },
  // ];

  // selected: Stars = null;
  // hasRated = false;
  domain$: Observable<Domain>;

  constructor(
    private articleService: ArticleService,
    private questionService: FaqService,
    private meService: MeService,
    private router: Router,
    private store: Store,
  ) {
    this.domain$ = this.store.select(selectDomain);
  }

  // select(index: number) {
  //   if (this.type !== 'article' && this.type !== 'question') {
  //     return false;
  //   }
  //   this.stars.forEach((star) => {
  //     star.selected = false;
  //   });
  //   this.stars[index].selected = true;
  //   this[`${this.type}Service`].rate(this.uuid, this.stars[index].rating);
  //   this.hasRated = true;
  // }

  // updateDisplayText(domain: Domain) {
  //   if (environment.application === "merlin") {
  //     this.displayText = "l'équipe Merlin";
  //   } else if (domain && domain.slug === "fo-sante") {
  //     this.displayText = "l'équipe Tract";
  //   } else {
  //     this.displayText = "vos représentants";
  //   }
  // }

  onShareClick(): void {
    if (!this.canShare) {
      return;
    }
    this.shareClicked.emit();
  }

  goToContact(): void {
    this.meService.allChats().pipe(
      take(1),
      catchError(() => of([] as Chat[])),
    ).subscribe((chats: Chat[]) => {
      this.router.navigateByUrl(chats.length ? '/chats' : '/new-chat');
    });
  }

  canDisplayContactButton(domain: Domain): boolean {
    return !!domain?.chat?.is_activated && domain.chat.is_maviepro_contact_activated !== false;
  }

  get suggestionsTitle(): string {
    const count = this.faqSuggestions?.length || 0;
    return `${count} question${count > 1 ? 's' : ''} en lien avec le sujet`;
  }

  onSuggestionClick(result: SearchResult): void {
    this.suggestionSelected.emit(result);
  }

  formatSuggestionBody(response: string): string {
    return (response || '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
